// export * from "./FeatureObject";
import {UserAccount} from '../__generated__/resolvers-types';
import {FeatureObject} from '../types/FeatureObject';
import {FeatureStatus} from '../types/FeatureStatus';
import {filterByExcludeStatus} from '../util/feature/filterByExcludeStatus';
import {filterByIncludeStatus} from '../util/feature/filterByIncludeStatus';
import {filterByPermission} from '../util/feature/filterByPermission';
import {filterForOwner} from '../util/feature/filterForOwner';
import {etsyFeatures} from './etsy';
import * as future from './future';
import {otherFeatures} from './other';

const features = {
  ...etsyFeatures,
  ...future,
  ...otherFeatures,
};

/**
 * Get all feature objects
 * - used for building router
 * @returns all features
 */
export function getAllFeatures(): FeatureObject[] {
  return Object.values(features);
}

/**
 * Generate feature list
 * - this list will be for actual use
 * @param user
 * @param filters
 * @returns
 */
export function getFeatures(
  user?: UserAccount | null,
  filters?: {includeStatus?: FeatureStatus[]; excludeStatus?: FeatureStatus[]},
): FeatureObject[] {
  return getAllFeatures()
    .filter(filterByExcludeStatus([FeatureStatus.PLANNED])) // planned features does not exists, only for external website
    .filter(filterByPermission(user)) // only show features that user has permission to see
    .filter(filterForOwner(user)) // filter for owner/admin features
    .filter(filterByIncludeStatus(filters?.includeStatus)) // filter by include status
    .filter(filterByExcludeStatus(filters?.excludeStatus)); // filter by exclude status
}

/**
 * Feature for external website
 * - remove admin and retired features
 * - only show features that is flagged to show on the front page
 */
export function getFeatureForExternal(): FeatureObject[] {
  const featureList = getAllFeatures();

  return featureList
    .filter((f) => f.showFeatureFrontPage)
    .filter(filterByExcludeStatus([FeatureStatus.RETIRED, FeatureStatus.ADMIN]));
}
